export enum ReturnModalEnum {
    OPTIONS = 'options',
    QUICK = 'quick',
}
